import React, { PureComponent } from 'react';
import { getTranslate } from 'react-localize-redux';
import { toggleConfirmationModal } from './confirmationModalActions';
import { connect } from 'react-redux';
import { withActions } from 'actionware';
import './confirmationModal.less'
import { Button } from 'antd';
@connect(({ localize, 
    confirmation: { showingConfirmationModal, action }}) => ({
    translate: getTranslate(localize),
    showingConfirmationModal,
    action
}))
@withActions({
    toggleConfirmationModal,
})
export default class ConfirmModalContent extends PureComponent {

  componentWillReceiveProps(nextProps) {
    if (nextProps.showingConfirmationModal && !this.props.showingConfirmationModal) {
    }
  }

  render() {
    const {translate, title, subtitle} = this.props
    return (
      <>
        <div className='confirm-modal-content-container'>
            <div className='confirm-content-image-container confirm-success-content-image'>

            </div>
            <div className='confirm-content-container'>
                <p className='confirm-content-title'>
                    {translate(title)}
                </p>
                <p className='confirm-content'>
                    {translate(subtitle)}
                </p>
                <div className='confirm-modal-content-container confirm-modal-buttons'>
                  <Button type="secondary" onClick={this.props.onCancel}>
                    {translate("confirmationModal.button_cancel")}
                  </Button>
                  <Button type="primary" onClick={this.props.onOk}>
                    {translate("confirmationModal.button_confirm")}
                  </Button>
              </div>
            </div>
        </div>
      </>
    )
  }
}
